import { ref } from 'vue';

export default () => {
  const isActive = ref(false);

  const setIsActive = (value: boolean) => {
    isActive.value = value;
  };

  return [isActive, setIsActive] as const;
};
